import { Amplify } from 'aws-amplify';
import { installSafeAmplifyFetch } from './safe-fetch.util';

export interface JeptoUserPoolAmplifyConfig {
	appSyncConfig: {
		graphqlEndpoint: string;
		region: string;
		customEndpoint: string;
		eventsEndpoint: string;
	};
	cognitoSettings: {
		ClientId: string;
		UserPoolId: string;
	};
}

/**
 * Install safe fetch and configure Amplify for Jepto apps using Cognito user pools.
 * Call once before bootstrap, before any Amplify API usage.
 */
export function configureJeptoUserPoolAmplify(
	config: JeptoUserPoolAmplifyConfig
): void {
	installSafeAmplifyFetch();
	Amplify.configure({
		API: {
			GraphQL: {
				endpoint: config.appSyncConfig.graphqlEndpoint,
				region: config.appSyncConfig.region,
				customEndpoint: config.appSyncConfig.customEndpoint,
				defaultAuthMode: 'userPool',
			},
			Events: {
				endpoint: config.appSyncConfig.eventsEndpoint,
				region: config.appSyncConfig.region,
				defaultAuthMode: 'userPool',
			},
		},
		Auth: {
			Cognito: {
				userPoolClientId: config.cognitoSettings.ClientId,
				userPoolId: config.cognitoSettings.UserPoolId,
			},
		},
	});
}
